import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { COMPARISON } from '../../data/content';
export function Comparison() {
  return <section className="relative w-full bg-ink px-5 py-12 sm:py-16" data-id="element-36" data-mp="34qswpd5tndhv">
      <div className="mx-auto max-w-4xl" data-id="element-37" data-mp="30nd6aykci9dm">
        <h2 className="text-center font-display text-3xl text-white sm:text-5xl" data-id="element-38" data-mp="30q932jkgis0h">
          ¿Cuánto cuesta <span className="text-magenta" data-id="element-39" data-mp="2vro1afpk409x">NO</span> tenerlo?
        </h2>

        <div className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-40" data-mp="2qrtasd9p1cpe">
          <div className="rounded-xl border border-red-500/30 bg-red-500/5 p-4 sm:p-5" data-id="element-41" data-mp="2lz06fqi506du">
            <h3 className="flex items-center gap-2 font-display text-xl text-red-400" data-id="element-42" data-mp="2h05oeqrzulus">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-43" data-mp="2cytwgelndojf" /> Sin Megapack
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-44" data-mp="2cx0mapbtsm6o">
              {COMPARISON.map(c => <li key={c.without} className="flex items-start gap-2" data-id="element-45" data-mp="281totz95gdq7">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-500" aria-hidden="true" data-id="element-46" data-mp="231yxxvpdjo55" />
                  <span className="text-sm leading-snug text-white/70" data-id="element-47" data-mp="3kix9favwk036">{c.without}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border border-lime/40 bg-lime/5 p-4 sm:p-5" data-id="element-48" data-mp="3bjaijj0sucod">
            <h3 className="flex items-center gap-2 font-display text-xl text-lime" data-id="element-49" data-mp="3bh7jyalkzb81">
              <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-50" data-mp="3gg0xg30vb287" /> Con Megapack
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-51" data-mp="807ezimz7goi">
              {COMPARISON.map(c => <li key={c.with} className="flex items-start gap-2" data-id="element-52" data-mp="c3dkup66f5ug">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-53" data-mp="3u8gr4d7vpnwg" />
                  <span className="text-sm leading-snug text-white/85" data-id="element-54" data-mp="325xh2577pf5">{c.with}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}